export default "__VITE_ASSET__CpYT0jFw__"